import React, {FC} from 'react';

import st from './authLayout.module.scss'

interface AuthLayout {
  children?: React.ReactNode
}

const AuthLayout: FC<AuthLayout> =({children})=>{
    return(
        <div className={st.container}>
            {children}
        </div>
    )
}
export default AuthLayout;